import React from 'react';
import {ReactComponent as DownArrayIcon} from '../../../../../../../assets/main/test/down-arrow.svg';
import {ReactComponent as UpArrayIcon} from '../../../../../../../assets/main/test/up-arrow.svg';




export const TestRowThead = () => {

    return (
        <div className="row thead">
            <div className="col test-col auto-width">Тест</div>
            <div className="col group-col">Группа</div>
            <div className="col students-col">Студенты</div>
            <div className="col passed-test-col align-right">Прошли тест</div>
        </div>
    );
};


// interface ITestRowThead {
//     onSortChange: (newSortDirection: string, newSortBy: string) => void;
//     sortDirection: string;
//     sortBy: string;
// }
//
// export const TestRowThead = ({onSortChange,sortDirection, sortBy}: ITestRowThead) => {
//
//     const handleSortClick = () => {
//         const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
//         onSortChange(newSortDirection, sortBy);
//     };
//
//     return (
//         <div className="row thead">
//             <div className="col test-col auto-width">Тест</div>
//             <div className="col group-col">
//                 <div style={{display: "inline-block"}}>
//           <span className="sort-tbl-btn" onClick={handleSortClick}>
//             Группа
//             <span className="sort-btn">
//                  <UpArrayIcon />
//                  <DownArrayIcon />
//             </span>
//           </span>
//                 </div>
//             </div>
//             <div className="col students-col">Студенты</div>
//             <div className="col passed-test-col align-right">Прошли тест</div>
//         </div>
//     );
// };
